import { render, staticRenderFns } from "./GrupoDeAcesso.vue?vue&type=template&id=41c219fd"
import script from "./GrupoDeAcesso.vue?vue&type=script&lang=js"
export * from "./GrupoDeAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports